import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './card.module.scss';
import DemoBadge from '@/components/demo-badge/demo-badge';
import { DemoBadgeVariant } from '@/components/demo-badge/demo-badge.types';

interface CardProps {
  title?: string;
  hint?: string;
  /** Marks the card's data as absent. `title` stays a string so these stay greppable. */
  demoBadge?: DemoBadgeVariant;
  children?: ReactNode;
  className?: string;
}

/**
 * A plain section, not a wrapper over antd Card: the mockup's card has a title
 * and a hint line inside one padded box, where antd splits head and body into
 * separately padded regions that have to be flattened to match.
 */
export default function Card({ title, hint, demoBadge, children, className }: CardProps) {
  return (
    <section className={clsx(styles.card, className)}>
      {(title || demoBadge) && (
        <h3 className={styles.title}>
          {title}
          {demoBadge && <DemoBadge variant={demoBadge} />}
        </h3>
      )}
      {hint && <p className={styles.hint}>{hint}</p>}
      {children}
    </section>
  );
}
